export default "__VITE_ASSET__CHRxe8dQ__"